/*eslint-disable */
import {bus} from '@/main';  
import toast from '@/services/toast';
export default {
  name: 'support-join-request-popup',
  components: {},
  props: ['joinID'],
  data () {
    return {
      selfUserId:''
    }
  },
  computed: {

  },
  mounted () {
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    closeJoinRecord() {
      bus.$emit('supportGroupJoinRequestPopupStateBus', false)
      document.body.classList.remove('popup_open_body')
    },
    confirmJoinRecord(){
      let data = {
        active:false,
        user:this.selfUserId,
        support_group:this.joinID
      }
      this.$store.dispatch('updateSGMemberFunc', data).then((res) => {
        toast.success(res.data.msg);
        this.getSGListFun()
        this.closeJoinRecord();
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
      })
    },
    getSGListFun() {
      this.$store.dispatch('getSGInfoNByIdApiFun', {id:this.joinID})
    },
  }
}